import React from 'react';
import { useTheme } from '@material-ui/core';
import { useSelector } from 'dva';
import DataTableNativeML from '@/components/DataTableNativeML';
import TablePagesStyled from './TablePagesStyled';
import { fmtThousand } from '@/utils/comUtil';

const AnalysisResult = (props) => {
  const { setPageData, pagination } = props;

  const loadingEffect = useSelector((state) => state.loading);
  const loading =
    loadingEffect.effects['crowdDetail/getQueryGroupHistoryPaget'];
  const crowdPageDetailList = useSelector(
    (state) => state.crowdDetail.crowdPageDetailList,
  );

  const { data, total } = crowdPageDetailList || {};

  const theme = useTheme();

  const columns = [
    {
      align: 'center',
      title: '基准日期',
      id: 'baseDate',
      key: 'baseDate',
    },
    {
      title: '人数',
      align: 'center',
      id: 'quantity',
      key: 'quantity',
      render: (item) => {
        return (
          <span textAlign="center">
            {item.quantity !== null ? fmtThousand(item.quantity, 0) : ''}
          </span>
        );
      },
    },
    {
      title: '计算状态',
      align: 'center',
      id: 'computeStatusName',
      key: 'computeStatusName',
    },
    {
      title: '最新成功计算时间',
      align: 'center',
      id: 'computeTime',
      key: 'computeTime',
      width: 180,
    },
  ];

  return (
    <TablePagesStyled theme={theme}>
      <div className="table-wrap">
        <DataTableNativeML
          total={total}
          loading={loading}
          paging={true}
          columns={columns}
          page={pagination}
          changePage={(pageObj) => {
            setPageData(pageObj);
          }}
          data={data}
        ></DataTableNativeML>
      </div>
    </TablePagesStyled>
  );
};

export default AnalysisResult;
